import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDoc from "../../../../modules/SimpleDoc";
import Api from "../../../../Services/Api";
import { fetchDataAsync } from "../../../../Services/Utils";
import { HttpStatus } from "../../../common/Constants";
import { saveAs } from "file-saver";

class MasterHargaJasaUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      warningModalVisible: false,
      warningMessage: null,
      typeWarning: null,
    };
  }

  handleDownloadTemplate = async () => {
    this.props.triggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA_FILE")
        .downloadTemplateExcelMasterHargaJasa,
      menuName: "Upload Master Harga Jasa",
      setError: this.props.setError,
      args: {},
    });
    this.props.triggerLoading();
    if (res.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "TEMPLATE_MASTER_HARGA_JASA.xlsx");
    }
  };

  changeInput = (fileName, file) => {
    if (file) {
      this.setState((prevValue) => ({ ...prevValue, data: file }));
    }
  };

  handleSubmit = async () => {
    const file = this.state.data;
    this.props.triggerLoading();
    const renamedFile = new File([file], "TEMPLATE_MASTER_HARGA_JASA.xlsx", {
      type: file.type,
    });
    const formData = new FormData();
    formData.append("file", renamedFile);
    let res = await Api.create(
      "NAGAMAS_MASTER_DATA"
    ).uploadExcelMasterHargaJasa(formData);
    this.props.triggerLoading();
    const component = document.getElementById("inputFile");
    if (component && component.value) {
      component.value = "";
    }
    console.log(res?.data?.message, res.data?.message?.includes("kesalahan"))
    if (res.ok && !res?.data?.message?.includes("kesalahan")) {
      this.props.onSuccessUpload(
        res.data.data?.map((item) => ({
          ...item,
          isSaved: true,
        }))
      );
    }
    if (res.ok && (res?.data?.message?.includes("kesalahan") || res?.data?.code === 503)) {
      return this.handleWarningModalVisibility(
        "Terdapat kesalahan pengisian data upload. Mohon diperbaiki dan upload kembali kemudian."
      );
    }
  };

  downloadLogError = async () => {
    try {
      const res = await Api.create(
        "NAGAMAS_MASTER_DATA_FILE"
      ).downloadLogExcelMasterHargaJasa();
      if (res.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "Master_Harga_Jasa_Log_Error.xlsx");
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  handleWarningModalVisibility = (text, typeWarning) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      typeWarning: R.isNil(typeWarning) ? 1 : typeWarning,
      warningModalVisible: !prevState.warningModalVisible,
    }));
  };

  render() {
    return (
      <React.Fragment>
        <SimpleModal
          title="Upload Master Harga Jasa"
          visible={this.props.visible}
          onClickClose={this.props.onClickClose}
          styles={{ width: "50%" }}
          content={
            <ModalContainer>
              <FlexView vAlignContent="center">
                <div className="margin-5px">
                  <div className="txt-site txt-11 txt-main txt-bold">
                    <h4>Template file dapat diunduh</h4>
                  </div>
                </div>
                <SimpleButton
                  text="DISINI"
                  onClick={this.handleDownloadTemplate}
                  className="margin-top-5px"
                />
              </FlexView>

              <FlexView
                vAlignContent="center"
                className="margin-bottom-20px margin-top-20px"
              >
                <SimpleDoc
                  readOnly
                  idInputFile="inputFile"
                  onChange={this.changeInput}
                />
              </FlexView>

              <FlexView
                hAlignContent="right"
                className="margin-bottom-20px margin-top-20px"
              >
                <SimpleButton
                  styles={{ width: "250px" }}
                  onClick={this.handleSubmit}
                  disabled={this.state.data.length === 0}
                >
                  Validasi & Upload File
                </SimpleButton>
              </FlexView>
              {this.state.warningModalVisible && (
                <SimpleAlert
                  title={"Information"}
                  content={
                    <div>
                      <p>
                        {this.state.warningMessage}
                        <br />
                        Mohon periksa kembali.
                      </p>
                    </div>
                  }
                  visible={this.state.warningModalVisible}
                  onClickClose={this.handleWarningModalVisibility}
                  additionalButtons={
                    <FlexView
                      vAlignContent={"center"}
                      style={{ justifyContent: "end", gap: "20px" }}
                    >
                      <SimpleButton
                        type="button"
                        text="Tutup"
                        onClick={() => this.handleWarningModalVisibility()}
                      />

                      {R.equals(this.state.typeWarning, 1) && (
                        <SimpleButton
                          type="button"
                          text="Download Log Error"
                          onClick={() => this.downloadLogError()}
                        />
                      )}
                    </FlexView>
                  }
                />
              )}
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default MasterHargaJasaUpload;
